/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'element-heading': {
    width: 16,
    height: 16,
    viewBox: '0 0 48 48',
    data: '<rect pid="0" x="2" y="5" width="43" height="5" rx="2.5"/><rect pid="1" x="2" y="16" width="43" height="5" rx="2.5"/><path pid="2" d="M2 29.5A2.5 2.5 0 0 1 4.5 27h38a2.5 2.5 0 0 1 0 5h-38A2.5 2.5 0 0 1 2 29.5z"/><rect pid="3" x="2" y="38" width="29" height="5" rx="2.5"/>'
  }
})
